interface InfoCardProps {
  title: string;
  description: string;
  imageSrc: string;
  index?: number;
  reverse?: boolean;
}

export const InfoCard = ({ title, description, imageSrc, index, reverse }: InfoCardProps) => {
  return (
    <article className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
      {/* Image column — varied aspect to break the AI 4:3 grid feel */}
      <div className={`md:col-span-7 ${reverse ? 'md:col-start-6' : ''}`}>
        <div
          className={`relative w-full overflow-hidden rounded-[20px] bg-[#F0F0EC] group ${
            index !== undefined && index % 2 === 0 ? 'aspect-[16/11]' : 'aspect-[4/3]'
          }`}
        >
          <img
            src={imageSrc}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]"
          />
          {typeof index === 'number' && (
            <span className="absolute top-5 left-5 text-white/90 text-[12px] font-mono tracking-wider">
              {String(index + 1).padStart(2, '0')} / 03
            </span>
          )}
        </div>
      </div>

      {/* Text column */}
      <div className={`md:col-span-5 ${reverse ? 'md:col-start-1 md:row-start-1' : ''}`}>
        <div className="max-w-[420px]">
          <h3 className="text-[#0D0A00] text-[28px] md:text-[34px] font-medium tracking-[-0.025em] leading-[1.05] mb-5">
            {title}
          </h3>
          <p className="text-[16px] text-[#0D0A00]/65 leading-[1.65]">
            {description}
          </p>
        </div>
      </div>
    </article>
  );
};
